import React from 'react';
import Layout from '../layout';
import HardwareHero from '../assets/v2/png/HardwareHero.png';
import CustomSectionOne from '../components/Esper/CustomHardware/CustomHardwareSectionOne';
import CustomSectionTwo from '../components/Esper/CustomHardware/CustomHardwareSectionTwo';
import CustomSectionThree from '../components/Esper/CustomHardware/CustomHardwareSectionThree';
import CustomSectionFour from '../components/Esper/CustomHardware/CustomHardwareSectionFour';
import CustomSectionFive from '../components/Esper/CustomHardware/CustomHardwareSectionFive';
import CustomSectionSix from '../components/Esper/CustomHardware/CustomHardwareSectionSix';
// import HardwareSectionFour from '../components/Esper/Hardware/HardwareSectionFour';
import OurPartnersContactUs from '../components/Esper/OurPartnersContactUs';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    ogImage={HardwareHero}
    messages={messages}
    title={'Custom Device Development with Esper and MediaTek'}
    description={`Build a custom Android Kiosk, rugged device or other hardware with Esper and MediaTek for fast results and better enterprise mobile security. `}
    keywords={`Custom android device, custom kiosk, custom rugged devices, custom hardware and Operating system`}
    className="first-page"
    location={props.location}
  >
    <CustomSectionOne />
    <CustomSectionTwo />
    <CustomSectionThree />
    <CustomSectionFive />
    <CustomSectionFour />
    <CustomSectionSix />
    <OurPartnersContactUs
      companies={['mediateknew', 'innocom']}
      title={`Our Partners `}
    />
  </Layout>
);
